import { initializeApp } from "firebase/app";
import {
    getAuth,
    signInWithCustomToken,
    signOut
} from "firebase/auth";
import {
    getFirestore,
    doc,
    collection,
    query,
    orderBy,
    limit,
    where,
    onSnapshot,
    updateDoc,
    startAfter,
    getDocs,
    serverTimestamp,
    setDoc,
    documentId
} from "firebase/firestore";
import * as Database from 'firebase/database';
import axios from "axios";
import { URL } from '../../constants';
import {
    CredentialsCompany,
    Token,
    PhoneCompany,
    IdCompany,
    IdUser,
    StatusUser,
    Username,
    Functionality
} from '../../contexts/auth';
import { IdChatOpen } from '../../contexts/chat';
import { api, apiAudio } from '../api';

const token = Token();
var firebaseApp = null;
var dbFirestore = null;
var dbDataBase = null;
var auth = null;
var after = null;

if (CredentialsCompany()) {
    firebaseApp = initializeApp(JSON.parse(CredentialsCompany()));
    auth = getAuth(firebaseApp);
    dbFirestore = getFirestore(firebaseApp);
    dbDataBase = Database.getDatabase(firebaseApp);
};
export function db() {
    return dbFirestore;
};
export function getChats(setChats, handlerContNewChats) {
    const unsubscribe = onSnapshot(
        doc(dbFirestore, "users", PhoneCompany()),
        (snapshot) => {
            if (!snapshot.exists) return unsubscribe();
            const chats = snapshot.data().chats.reverse().filter((item) => item?.em_atendimento === 'N');
            handlerContNewChats([...chats]);
            setChats([...chats]);
        },
        (error) => {
            return unsubscribe();
        }
    );
};
export async function convertChats(phoneChat) {
    const q = query(
        collection(doc(dbFirestore, "chats_new", `${phoneChat}`), "messages"),
        orderBy("date", "desc"),
        limit(1)
    );
    const docRef = await getDocs(q);
    if (docRef.size < 1) return await api.post(`/chats/convert?phone=${phoneChat}&empresa_id=${IdCompany()}`)
    return
};
export async function getMessages(phoneChat, setMessageList, onScroll) {
    const q = query(
        collection(doc(dbFirestore, "chats_new", `${phoneChat}`), "messages"),
        orderBy("date", "desc"),
        limit(200)
    );
    const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
            if (phoneChat !== IdChatOpen()) return unsubscribe();
            const { docs } = snapshot;
            after = docs[docs.length - 1];
            const messages = docs.map((docMessage) => ({
                ...docMessage.data(),
                docMessage_id: docMessage.id
            }));
            setMessageList(messages.reverse());
            onScroll();
        },
        (error) => {
            return unsubscribe();
        }
    );
};
export async function getMessagesOld(phoneChat, setMessageList, stopLoading) {
    const q = query(
        collection(doc(dbFirestore, "chats_new", `${phoneChat}`), "messages"),
        orderBy("date", "desc"),
        startAfter(after),
        limit(50)
    );
    const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
            if (phoneChat !== IdChatOpen()) return unsubscribe();
            after = snapshot.docs[snapshot.docs.length - 1];
            if (!after) {
                stopLoading();
                return unsubscribe();
            }
            var messages = [];
            snapshot.docs.reverse().forEach((item) => {
                var message = item.data()
                message.docMessage_id = item.id
                messages.push(item.data())
            });
            setMessageList(oldState => {
                return [...messages, ...oldState]
            });
            stopLoading();
        },
        (error) => {
            return unsubscribe();
        }
    );
};
export async function eventsUsers(ids, event) {
    const q = query(
        collection(dbFirestore, "events_user"),
        where(documentId(), 'in', ids),
    );
    let hasInitialLoadHappened = false;

    const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
            if (!hasInitialLoadHappened) {
                // Ignora o primeiro snapshot, que é o carregamento inicial
                hasInitialLoadHappened = true;
                return;
            }
            snapshot.docs.forEach(change => {
                const index = change.data().events.length - 1;
                event(change.data().events[index].type);
            })
        },
        (error) => {
            return unsubscribe();
        }
    );
};
export async function getNotifications(onAlertNotification) {
    if (!IdUser()) return;
    const q = query(
        collection(dbFirestore, "notifications"),
        where("to", "==", parseInt(IdUser())),
        where("viwer", "==", false),
    );
    const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
            snapshot.docChanges().forEach((change) => {
                if (change.type !== "added") return
                onAlertNotification(change.doc.id, change.doc.data());
            });
        },
        (error) => {
            return unsubscribe();
        }
    );
};
export async function stopNotification(id) {
    const docRef = doc(dbFirestore, "notifications", `${id}`);
    await updateDoc(docRef, {
        viwer: true,
    })
};
export async function newContact(name, phone) {
    try {
        const { data: { cliente } } = await api.post(`/new_contact?name=${name}&phone=${phone}`);
        return { status: 'success', message: 'Contato Criado !', cliente: cliente }
    } catch (error) {
        if (error?.response) {
            return { status: 'error', message: error?.response?.data?.message }
        } else {
            return { status: 'error', message: '' }
        }
    }

};
export async function getContactByNumber(number_client) {
    try {
        const { data } = await api.get(`/clients?number_client=${number_client}&number_key=${PhoneCompany()}`)
        return data;
    }
    catch (error) {
        return null
    }
};
export async function getMsgTemplate(owner) {
    try {
        const { data } = await api.get(`get_template_by_number?phone=${PhoneCompany()}${owner ? `&owner=${owner}` : ''}`)
        return data
    }
    catch (error) {
        return false
    }
};
export async function getCategoryTemplate(owner) {
    try {
        const { data } = await api.get(`get_category_template_by_number?phone=${PhoneCompany()}${owner ? `&owner=${owner}` : ''}`)
        return data
    }
    catch (error) {
        return false
    }
};
export async function getFullAccessibility() {
    try {
        const { data } = await api.get('/accessibility')
        return data
    }
    catch (error) {
        return false
    }
};
export async function getAccessibilityByPhone(phone) {
    try {
        const { data } = await api.get(`/accessibility-user?telephone=${phone}&empresa_id=${IdCompany()}`)
        return data
    }
    catch (error) {
        return false
    }
};
export async function postAccessibilityByPhone(phone, idAccessibility) {
    try {
        const { data } = await api.post(`/accessibility-user?telephone=${phone}&id_accessibility=${idAccessibility}`)
        return data
    }
    catch (error) {
        return false
    }
};
export async function getImage(id) {
    try {
        const { data: { data: url } } = await api.get(`webchat-image?id_image=${id}&origin=API`)
        return url
    }
    catch (error) {
        return false
    }
};
export async function getVideo(id) {
    try {
        const { data: url } = await api.get(`webchat-video?id_video=${id}&origin=API`)
        return url
    }
    catch (error) {
        return false
    }
};
export async function getMidia(id) {
    let params = {
        bucket: 'whatsapp-images-teste',
        id,
    }
    try {
        const { data } = await api.get('/midia', { params: params })
        return data
    }
    catch (error) {
        return false
    }
};
export async function sendDocument(file, message, to, customerId) {
    const data = new FormData()
    data.append('file', file)
    data.append('to', to)
    data.append('message', message)
    data.append('customer_service_id', customerId)
    var config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    };
    try {
        return axios.post(URL.base + '/webchat-document', data, config)
    }
    catch (error) {
        console.log(error)
    }
};
export async function sendFiles(files, message, to, customerId) {
    const data = new FormData()
    files.forEach((file) => {
        data.append('files', file)
    })
    data.append('to', to)
    data.append('message', message)
    data.append('customer_service_id', customerId)
    var config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    };
    try {
        return axios.post(URL.base + '/webchat-files', data, config)
    }
    catch (error) {
        return false;
    }
};
export async function sendVoiceMic(file, to) {
    const data = new FormData()
    data.append('voice', file)
    data.append('to', to)
    var config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    };
    try {
        return axios.post(URL.base + '/webchat-voice-mic', data, config)
    }
    catch (error) {
        console.log(error)
    }
};
export async function sendVoice(file, message, to) {
    const data = new FormData()
    data.append('file', file)
    data.append('to', to)
    var config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        }
    };
    try {
        return axios.post(URL.base + '/v1/webchat-voice', data, config)
    }
    catch (error) {
        console.log(error)
    }
};
export async function getURLAudio(bucketName, filename) {
    try {
        const { data: { url } } = await apiAudio.post('/StorageURL', { bucket: bucketName, filename: filename });
        return url;
    } catch {
        return false
    }
};
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
};
export async function getToTextAudio(bucketName, filename) {
    const maxAttempt = 3;
    let attempt = 1;
    while (attempt <= maxAttempt) {
        try {
            const { data: { texto } } = await apiAudio.post('/SpeechToText', { bucket: bucketName, filename: filename });
            return texto;
        } catch (error) {
            attempt++;
            if (attempt <= maxAttempt) {
                await delay(1000);
            }
        }
    }
    return false;
};
export async function sendMessage(to, typeMessage, message, customerId) {

    if (Functionality().includes('envio_assinatura')) {
        message = `*[${Username().trim()}]*\n${message}`;
    }

    try {
        var data = {
            to: to,
            type_message: typeMessage,
            message: message,
            customer_service_id: customerId
        }
        const response = await api.post('/webchat', data);
        return response
    } catch {
        return false
    }
};
export async function sendVideoTemplate(phone_to, customer_service_id, token) {
    try {
        var data = {
            phone_to,
            token,
            customer_service_id
        }
        const response = await api.post('/send_video_template', data);
        return response
    } catch (error) {
        throw error
    }
};
export async function sendVideoBotucatu(phone_to, customer_service_id, client_id, cd_it_agenda_central, token ) {    
    try {
        var data = {
            phone_to,
            customer_service_id,
            client_id,
            cd_it_agenda_central,
            token
        }
        const response = await api.post('/video-chamada-botucatu', data);
        return response
    } catch (error) {
        throw error
    }
}
export async function monitoringStatusUser() {

    //Obter o custom token do usuario atravez da API
    const { data: { custom_token } } = await api.get('/custom-token');

    function rtdb_and_local_fs_presence() {
        const uid = auth.currentUser.uid;
        Database.onValue(Database.ref(dbDataBase, '.info/connected'),
            (snap) => {
                if (snap.val() === false) {
                    setDoc(
                        doc(dbFirestore, '/status/' + uid),
                        { state: 'offline', last_changed: serverTimestamp() }
                    );
                    return
                };
                Database.onDisconnect(Database.ref(dbDataBase, '/status/' + uid))
                    .set({ state: 'offline', last_changed: Database.serverTimestamp() })
                    .then(() => {
                        Database.set(
                            Database.ref(dbDataBase, '/status/' + uid),
                            { state: `${StatusUser()}`, last_changed: Database.serverTimestamp() }
                        );
                    });
            });
    };
    signInWithCustomToken(auth, custom_token).then(function (e) {
        rtdb_and_local_fs_presence();
    }).catch(function (err) {
        console.warn(err);
        console.warn('Please enable Anonymous Authentication in your Firebase project!');
    });
};
export async function stopMonitoringStatusUser() {
    try {
        //--> Mudar manualmete para offline <--
        const uid = auth.currentUser.uid;
        Database.set(Database.ref(dbDataBase, '/status/' + uid), { state: 'offline', last_changed: Database.serverTimestamp() });
        signOut(auth).then(() => {
            // Sign-out successful.
        }).catch((error) => {
            console.log(error)
        });
        return true
    } catch {
        return false
    };
};
export async function getNote(id) {
    const { data } = await api.get(`/customerservice/note?id=${id}`);
    return data;
};
//busca o tempo que falta para expirar a sessão do chat
export async function getTimeExpireSession(phoneChat) {
    return api.get('TimeToExpireSession?phone=' + phoneChat).then(res => res.data.time_to_expire_session)
};
function onVerificationStatusTemplate(templateResponse) {
    if ('error_message' in templateResponse)
        return {
            success: false,
            message: `${templateResponse?.error_message?.details
                ? templateResponse?.error_message?.details
                : templateResponse?.error_message?.title
                }`
        };
    return { success: true, message: 'Sucesso ao enviar' };
};
export async function sendMsgTemplateParams(phone, template_id, param, customerId) {
    var body = {
        phone_to: phone,
        template_id: template_id,
        parametros: param.map(item => ({ param: item })),
        customer_service_id: customerId,
    }
    try {
        const { data } = await api.post('send_message_template', body)
        return onVerificationStatusTemplate(data);
    }
    catch (error) {
        return { success: false, message: 'Erro -- ' };
    }
};
export async function sendMsgTemplate(phone, id_msgTemplate, customerId) {
    try {
        const { data } = await api.post(`send_message_template?phone_to=${phone}&template_id=${id_msgTemplate}${customerId ? `&customer_service_id=${customerId}` : ''}`);
        return onVerificationStatusTemplate(data);
    }
    catch (error) {
        return { success: false, message: 'Erro -- ' };
    }
};
export async function sendDocumentByLink(to, link, filename, customer_service_id) {
    try {
        await api.post(`webchat-linked-document?to=${to}&link=${link}&filename=${filename}&customer_service_id=${customer_service_id}`);
        return { success: true, message: ' ' };
    }
    catch (error) {
        return { success: false, message: 'Erro -- ' };
    }
};